import { render, staticRenderFns } from "./CancelledConnectionDetailsDialog.vue?vue&type=template&id=85493f36&scoped=true"
import script from "./CancelledConnectionDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./CancelledConnectionDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./CancelledConnectionDetailsDialog.vue?vue&type=style&index=0&id=85493f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85493f36",
  null
  
)

export default component.exports